
import {CmonRequestServiceResponseData} from '../CmonRequestService';
import CmonError from './CmonError';

export default class CmonTryAgainError
    extends CmonError {

    constructor(jsonError: CmonRequestServiceResponseData) {
        super(jsonError);
    }

}
